import { Typography, julo } from '@julo-ui/react';
import { BottomSheet } from '@new-components/elements';
import FailedVerificationImage from 'assets/illustrations/failed-verification.png';

interface MotherMaidenNameErrorProps {
  open: boolean;
  onClose: () => void;
}

const MotherMaidenNameError = ({
  open,
  onClose,
}: MotherMaidenNameErrorProps) => {
  return (
    <BottomSheet
      display={open}
      onClose={onClose}
      title='Nama lengkap ibu kandung tidak sesuai'
      ctaText='Perbaiki'
    >
      <julo.img
        src={FailedVerificationImage}
        alt='Failed'
        style={{ width: '100%', height: 'auto', marginBottom: '16px' }}
      />
      <Typography
        type='body'
        color='var(--colors-neutrals-80)'
        sx={{ marginBottom: '16px', textAlign: 'center' }}
      >
        Yuk, perbaiki dan pastikan penulisan Nama lengkap ibu kandung sesuai KTP
        yang bersangkutan.
      </Typography>
    </BottomSheet>
  );
};

export default MotherMaidenNameError;
